import ApiService from './ApiService'

export const imageUploadApi = data => ApiService.filePost('/core/upload/', data)
